/**
 * @fileoverview gRPC-Web generated client stub for proto.services
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as proto_services_ali_sts_service_pb from '../../proto/services/ali_sts_service_pb';


export class AliyunSTSServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetAliyunSTSToken = new grpcWeb.MethodDescriptor(
    '/proto.services.AliyunSTSService/GetAliyunSTSToken',
    grpcWeb.MethodType.UNARY,
    proto_services_ali_sts_service_pb.GetAliyunSTSTokenRequest,
    proto_services_ali_sts_service_pb.GetAliyunSTSTokenResponse,
    (request: proto_services_ali_sts_service_pb.GetAliyunSTSTokenRequest) => {
      return request.serializeBinary();
    },
    proto_services_ali_sts_service_pb.GetAliyunSTSTokenResponse.deserializeBinary
  );

  getAliyunSTSToken(
    request: proto_services_ali_sts_service_pb.GetAliyunSTSTokenRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_ali_sts_service_pb.GetAliyunSTSTokenResponse>;

  getAliyunSTSToken(
    request: proto_services_ali_sts_service_pb.GetAliyunSTSTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_ali_sts_service_pb.GetAliyunSTSTokenResponse) => void): grpcWeb.ClientReadableStream<proto_services_ali_sts_service_pb.GetAliyunSTSTokenResponse>;

  getAliyunSTSToken(
    request: proto_services_ali_sts_service_pb.GetAliyunSTSTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_ali_sts_service_pb.GetAliyunSTSTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.AliyunSTSService/GetAliyunSTSToken',
        request,
        metadata || {},
        this.methodInfoGetAliyunSTSToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.AliyunSTSService/GetAliyunSTSToken',
    request,
    metadata || {},
    this.methodInfoGetAliyunSTSToken);
  }

  methodInfoGetOSSToken = new grpcWeb.MethodDescriptor(
    '/proto.services.AliyunSTSService/GetOSSToken',
    grpcWeb.MethodType.UNARY,
    proto_services_ali_sts_service_pb.GetOSSTokenRequest,
    proto_services_ali_sts_service_pb.GetOSSTokenResponse,
    (request: proto_services_ali_sts_service_pb.GetOSSTokenRequest) => {
      return request.serializeBinary();
    },
    proto_services_ali_sts_service_pb.GetOSSTokenResponse.deserializeBinary
  );

  getOSSToken(
    request: proto_services_ali_sts_service_pb.GetOSSTokenRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_ali_sts_service_pb.GetOSSTokenResponse>;

  getOSSToken(
    request: proto_services_ali_sts_service_pb.GetOSSTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_ali_sts_service_pb.GetOSSTokenResponse) => void): grpcWeb.ClientReadableStream<proto_services_ali_sts_service_pb.GetOSSTokenResponse>;

  getOSSToken(
    request: proto_services_ali_sts_service_pb.GetOSSTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_ali_sts_service_pb.GetOSSTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.AliyunSTSService/GetOSSToken',
        request,
        metadata || {},
        this.methodInfoGetOSSToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.AliyunSTSService/GetOSSToken',
    request,
    metadata || {},
    this.methodInfoGetOSSToken);
  }

}

